<template>
  <div class="form">
    <div class="step">
      <el-steps :active="active" align-center>
        <el-step v-for="(step, index) in step" :key="index" :description="step.desc"></el-step>
      </el-steps>
    </div>
    <div class="form_content">
      <transition name="fade01" mode="out-in">
        <router-view
          @page="setPage($event)"
          @transition="transitionPage($event)"
          @next="nextPage($event)"
          @back="backPage()"
        ></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import {Step} from '@/js/util/member/formOptionConstants'
import {mapActions, mapGetters} from 'vuex'
export default {
  data() {
    return {
      active: 1
    }
  },
  created() {
    this.updateHasCancel(true)
  },
  async mounted() {
    // キャンセル
    window.addEventListener('beforeunload', this.reload, false)

    this.setFinances()
    
    this.setOption(this.getHasPayment)
    this.setList()
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.reload, false)
    this.init()
    this.productInputInitForm()
    this.productInputUpdateValidations([])
    this.userInputInitForm()
    this.userInputUpdateValidations([])
  },
  computed: {
    ...mapGetters({
      getHasPayment: 'status/getHasPayment',
      getHasRegistration: 'status/getHasRegistration'
    }),
    step() {
      return Step[this.getHasRegistration]
    }
  },
  methods: {
    setPage(name) {
      let num = 1
      this.step.map((step, index) => {
        if (step.name === name) num = index + 1
      })
      this.active = num
    },
    transitionPage(name) {
      this.transitionSame(name)
    },
    nextPage(mode) {
      let query = null
      if (mode) {
        query = {mode}
      }

      // ページの移動
      const path = this.step[this.active].name
      this.transitionSame(path, query)

      if (path === 'form-done') {
        window.removeEventListener('beforeunload', this.reload, false)
      }
    },
    backPage() {
      // ページの移動
      const path = this.step[this.active - 2].name
      this.transitionSame(path)
    },
    reload(e) {
      //リロードすると警告がでる
      e.preventDefault()
      let message = 'このページを離れますか？'
      e.returnValue = message // Google Chrome
      return message // Google Chrome以外
    },
    ...mapActions({
      updateHasCancel: 'status/updateHasCancel',
      init: 'status/init',
      setFinances: 'productInput/setFinances',
      setOption: 'productInput/setOption',
      setList: 'productInput/setList',
      productInputInitForm: 'productInput/initForm',
      productInputUpdateValidations: 'productInput/updateValidations',
      userInputInitForm: 'userInput/initForm',
      userInputUpdateValidations: 'userInput/updateValidations'
    })
  }
}
</script>

<style lang="scss">
.form {
  &_content {
    margin-top: 20px;
  }
}
.step {
  margin-top: 15px;
  .el-step {
    &.is-center {
      .el-step__description {
        font-size: 11px;
        line-height: 1.2;
        padding: 15px 0 0;
      }
    }
  }
}
</style>
